var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "omegaup-overlay-popup",
    { on: { dismiss: _vm.onHide } },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "form",
          {
            staticClass: "h-auto w-auto",
            attrs: { "data-reviewewr-popup": "" },
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "container-fluid d-flex align-items-start flex-column"
              },
              [
                _vm.currentView === _vm.AvailableViews.Content
                  ? [
                      _c(
                        "p",
                        {
                          staticClass:
                            "h4 font-weight-bold pb-4 text-center w-100"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.T.reviewerNominationFormTitle) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "form-group w-100" },
                        [
                          _c("label", { staticClass: "control-label" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.T.reviewerNominationQuality) +
                                " "
                            )
                          ]),
                          _c("br"),
                          _c("omegaup-radio-switch", {
                            attrs: {
                              value: _vm.qualitySeal,
                              "selected-value": _vm.qualitySeal
                            },
                            on: {
                              "update:value": function($event) {
                                _vm.qualitySeal = $event
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "form-group w-100",
                          attrs: { "data-other-tag-input": "" }
                        },
                        [
                          _c("vue-typeahead-bootstrap", {
                            attrs: {
                              data: _vm.publicTags,
                              serializer: _vm.publicTagsSerializer,
                              placeholder: _vm.T.collecionOtherTags
                            },
                            on: { hit: _vm.addOtherTag }
                          }),
                          _c("br"),
                          _c(
                            "div",
                            { staticClass: "card-body table-responsive w-100" },
                            [
                              _c(
                                "table",
                                { staticClass: "table table-striped w-100" },
                                [
                                  _c("thead", [
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        attrs: { scope: "col" }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.T.contestEditTagName) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-center",
                                        attrs: { scope: "col" }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.T.contestEditTagDelete) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.publicTagsList, function(tag) {
                                      return _c("tr", { key: tag }, [
                                        _c(
                                          "td",
                                          { attrs: { "data-tag-name": "" } },
                                          [_vm._v(_vm._s(_vm.getName(tag)))]
                                        ),
                                        _c(
                                          "td",
                                          { staticClass: "text-center" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn btn-danger",
                                                attrs: {
                                                  type: "button",
                                                  disabled:
                                                    _vm.publicTagsList.length <
                                                    2
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeTag(tag)
                                                  }
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: ["fas", "trash"]
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ])
                                    }),
                                    0
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("div", { staticClass: "text-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary mr-3",
                            attrs: {
                              "data-review-submit-button": "",
                              type: "submit",
                              disabled: _vm.publicTagsList.length === 0
                            },
                            on: { click: _vm.onSubmit }
                          },
                          [_vm._v(" " + _vm._s(_vm.T.wordsSend) + " ")]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            attrs: { type: "button" },
                            on: { click: _vm.onHide }
                          },
                          [_vm._v(" " + _vm._s(_vm.T.wordsCancel) + " ")]
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm.currentView === _vm.AvailableViews.Thanks
                  ? [
                      _c("div", { staticClass: "w-100 h-100 h3 text-center" }, [
                        _vm._v(
                          " " + _vm._s(_vm.T.qualityFormThanksForReview) + " "
                        )
                      ])
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }